package fr.arcplex.network.model

/**
 * What a clicked rail item means for the UI. The backend's action URL/type
 * matching lives in the port implementation, so a new API only changes that
 * mapping instead of the navigation code.
 */
sealed interface ScreenAction {
    /** Close the burger menu (produced by a `displayMenu` item). */
    data object ToggleMenu : ScreenAction

    /** Open the film detail screen of [filmId]. */
    data class OpenFilm(val filmId: String) : ScreenAction

    /** Resolve [item] into a playback and start it. */
    data class Play(val item: RailItem) : ScreenAction

    /** Load the screen published at [url]. */
    data class OpenScreen(val url: String) : ScreenAction

    /** Nothing to do: log and drop, never fall back to a playback. */
    data object Ignore : ScreenAction
}
